// const SHELL_FLAG_CLIENT_ID = 'SHELL'; // @todo AV to clarify this
// const VERSION_ALIAS_FLAG_PREFIX = 'miniapp-versionalias';
export const VERSION_ALIAS_VALUE_DISABLED = 'DISABLED';
const gatewayUrlFormatRegex = /^(https:\/\/(?:[a-zA-z0-9]+[-])?x\..*\/.*\/.*\/).*(\/asset-manifest.json)/;
const directUrlFormatRegex = /^(https:\/\/)[a-zA-Z0-9-]*?(\.[a-zA-Z0-9-.]*\/asset-manifest.json)/;
/**
 * modify the version alias in the asset-manifest.json url if the shell has a matching flag.
 *
 * @todo Does the Nav Manager also use LaunchDarkly? If so it would be more ideal for the Nav Manager to do this
 * and provide config which we don't need to transform in the browser. That would also provide flexibility to change
 * the alias resolution algorithm in future
 *
 * example urls:
 * gatewayFormat:   https://x.nab.com.au/vpcKey/appName/versionAlias/asset-manifest.json
 * directFormat:    https://appName-versionAlias.randomhost.com.au/asset-manifest.json
 *
 * @param assetManifestUrl
 * @param flagVersionAlias - This is fetched from the FlagManager.
 * @param appId - appId this is the unique identifier for said mini-app, this is passed down via the appMetaData properties.
 */
export function getManifestUrlForVersionAlias(assetManifestUrl, flagVersionAlias, appId) {
    if (!assetManifestUrl)
        return;
    // Precautionary removal of returns and newlines from string to prevent regex DOS - Unlikely scenario given the data is trusted but can't hurt to be cautious
    const safeAssetManifestUrl = assetManifestUrl.replace(/[\r\n]/g, '');
    // appMetaData.assetManifestUrl = 'https://x.nab.com.au/vpcKey/appName/versionAlias/asset-manifest.json';
    // appMetaData.assetManifestUrl = 'https://appName-version-Alias.randomhost.com.au/asset-manifest.json';
    let isValid = true;
    let result = assetManifestUrl;
    console.log(`Getting version alias for original assetManifestUrl: ${assetManifestUrl}`);
    // collect the flag based versionAlias, and if resolved, update the assetManifestUrl
    if (flagVersionAlias === VERSION_ALIAS_VALUE_DISABLED) {
        result = VERSION_ALIAS_VALUE_DISABLED;
        isValid = false;
    }
    // if flagversion does not exist do not attempt to change the assetManifestURL.
    if (!flagVersionAlias || !appId) {
        isValid = false;
    }
    // determine if assetManifestUrl is served via a gateway
    if (isValid) {
        if (gatewayUrlFormatRegex.test(safeAssetManifestUrl)) {
            result = safeAssetManifestUrl.replace(gatewayUrlFormatRegex, `$1${flagVersionAlias}$2`);
        }
        else if (directUrlFormatRegex.test(safeAssetManifestUrl)) {
            // we need to retrieve the app id and the version alias as a single string.
            // we need to replace the app-id with (appName-FlagVersionAlias)
            result = safeAssetManifestUrl.replace(directUrlFormatRegex, `$1${appId}-${flagVersionAlias}$2`);
        }
    }
    // capture manifest versionAlias from assetManifestUrl
    console.log(`Version alias resolved: \n${[`Original assetManifestUrl: ${assetManifestUrl}`, `Updated assetManifestUrl: ${result}`].join('\n')}`);
    // TODO: investigate the possibility of adding a logger in here. But keep in mind circular dependency of this being apart of x-app-loaders.
    console.log(`assetManifestUrl result: ${result}`);
    return result;
}
//# sourceMappingURL=getManifestUrlForVersionAlias.js.map